import React, { useState, useEffect } from "react";
import { Container, Card, Button, Modal, Row, Col } from "react-bootstrap";
import { useParams } from "react-router-dom";
import {
  FacebookIcon,
  FacebookShareButton,
  WhatsappIcon,
  WhatsappShareButton,
  EmailIcon,
  EmailShareButton,
} from "react-share";
import HeroSection from "../utilities/HeroSection.jsx";
import useFetch from "../hooks/useFetch";
import ImageViewer from "../utilities/ImageViewer.jsx";
import ContentLoader from "react-content-loader";
import { PropagateLoader } from "react-spinners";
import { FaCalendarAlt } from "react-icons/fa";

import "react-image-gallery/styles/image-gallery.css";
import moment from "moment";

const ImageLoader = () => (
  <ContentLoader
    speed={2}
    width={200}
    height={200}
    viewBox="0 0 200 200"
    backgroundColor="#f3f3f3"
    foregroundColor="#ecebeb"
  >
    <rect x="0" y="0" rx="10" ry="10" width="200" height="200" />
  </ContentLoader>
);

const Gallery = ({ banners, isLoading, error }) => {
  const { type } = useParams();
  const events = useFetch("events/");
  const [currentEvents, setCurrentEvents] = useState([]);
  const [selectedEvent, setSelectedEvent] = useState(null);
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    setCurrentEvents(events);
  }, [events]);

  const handleEventClick = (event) => {
    setSelectedEvent(event);
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setSelectedEvent(null);
    setShowModal(false);
  };
  const formattedDate = (event_date) =>
    moment(event_date).format("MMMM D, YYYY");

  return (
    <>
      <HeroSection banners={banners} isLoading={isLoading} error={error} />

      <Container style={{ marginTop: "1rem", marginBottom: "1rem" }}>
        <Row xs={1} md={2} lg={3} xl={4}>
          {currentEvents && currentEvents.length > 0
            ? currentEvents.map((event) => (
                <Col key={event.id} className="mb-4">
                  <Card
                    className="event-card card-border"
                    style={{cursor:"pointer",}}
                    onClick={() => handleEventClick(event)}
                  >
                    {event.gallery[0]?.image ? (
                      <Card.Img
                      className="modal-title"
                        variant="top"
                        src={event.gallery[0].image}
                        alt={event.event_title}
                        style={{ height: "200px" }}
                      />
                    ) : (
                      <ImageLoader />
                    )}
                    <Card.Body>
                      <Card.Title
                        style={{
                          fontWeight: "bold",
                          fontSize: "1rem",
                          marginBottom: "0.5rem",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          whiteSpace: "nowrap",
                          color: "#d9001b",
                        }}
                        className="color-primary"
                      >
                        {event.event_title}
                      </Card.Title>
                      <Card.Text
                        style={{ fontSize: "0.9rem", color: "#005ca9" }}
                      >
                        <FaCalendarAlt style={{ marginRight: "0.5rem" }} />
                        {formattedDate(event.event_date)}
                      </Card.Text>
                    </Card.Body>
                  </Card>
                </Col>
              ))
            : null}
        </Row>
      </Container>

      <Modal show={showModal} onHide={handleCloseModal} size="lg">
      <Modal.Header closeButton>
        <Modal.Title className="modal-title">{selectedEvent?.event_title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {selectedEvent?.gallery && <ImageViewer gallery={selectedEvent?.gallery} />}
        <div className="share-buttons mt-3">
          <FacebookShareButton url={selectedEvent?.gallery[0]?.image} quote={selectedEvent?.event_title}>
            <FacebookIcon size={32} round={true} />
          </FacebookShareButton>
          <WhatsappShareButton url={selectedEvent?.gallery[0]?.image} title={selectedEvent?.event_title}>
            <WhatsappIcon size={32} round={true} />
          </WhatsappShareButton>
          <EmailShareButton url={selectedEvent?.gallery[0]?.image} subject={selectedEvent?.event_title}>
            <EmailIcon size={32} round={true} />
          </EmailShareButton>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleCloseModal}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
    </>
  );
};

export default Gallery;
